export default {
  install(Vue) {
    Vue.prototype.$copyToClipboard = copyToClipboard;
  },
};

function copyToClipboard($input) {
  doSelect.apply($input);

  document.execCommand("copy");
  window.getSelection().removeAllRanges();
}

function doIOSSelect() {
  const range = document.createRange();
  range.selectNodeContents(this);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  this.setSelectionRange(0, 999999);
}

function doSelect() {
  if (isIOS()) {
    return doIOSSelect.apply(this);
  }

  this.select();
}

function isIOS() {
  return navigator.userAgent.match(/ipad|iphone/i);
}
